import {all} from "redux-saga/effects";
import authSagas from "@/appRedux/sagas/Auth";
import systemSagas from "@/appRedux/sagas/System"

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    systemSagas()
  ]);
}
